/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/businesses/businessesActions";
import { useBusinessesUIContext } from "../BusinessesUIContext";

export function BusinessDeleteDialog({ id, show, onHide }) {
  // Businesses UI Context
  const businessesUIContext = useBusinessesUIContext();
  const businessesUIProps = useMemo(() => {
    return {
      setIds: businessesUIContext.setIds,
      queryParams: businessesUIContext.queryParams,
    };
  }, [businessesUIContext]);

  // businesses Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.businesses.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteBusiness = () => {
    // server request for deleting Business by id
    dispatch(actions.deleteBusiness(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchBusinesses(businessesUIProps.queryParams));
      // clear selections list
      businessesUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Business Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this business?</span>
        )}
        {isLoading && <span>Business is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteBusiness}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
